import { Link } from 'react-router-dom'

interface NavLinkProps {
 link: string
 onClick?: () => void
}

export function NavLink({ link, onClick }: NavLinkProps) {
 const url =
  link === 'home'
   ? '/'
   : '/' + link.normalize('NFD').replace(/[\u0300-\u036f]/g, '')

 return (
  <li className="indent-0 leading-[40px] pr-[17%]">
   <Link
    className="block relative left-0 z-10 no-underline text-black font-bold font-['rns-milesblack'] max-[768px]:text-[30px] text-[48px] max-[768px]:leading-[50px] leading-[66px] hover:text-white hover:left-[10px] hover:transition-[left] duration-500 ease-in-out"
    to={url}
    onClick={onClick}
    aria-label={`Ir para a página ${link}`}
    role="link"
   >
    {link}
   </Link>
  </li>
 )
}
